import { Redirect } from "react-router-dom";

export const Dashboard = () => <Redirect to="/phish/tags" />;
